export const SET_SHOW_LOGIN_POPUP = 'SET_SHOW_LOGIN_POPUP';

export const FETCH_TRANSLATION = 'FETCH_TRANSLATION';
export const FETCH_TRANSLATION_FAILED = 'FETCH_TRANSLATION_FAILED';
export const FETCH_TRANSLATION_SUCCESSFUL = 'FETCH_TRANSLATION_SUCCESSFUL';
